import React from "react"
import InfoBg from "../../images/sections/technologies/info-background.webp"
import { CONSTANTS } from "../../utils/const"

const CommonInfo = ({ data, maxWidth }) => {
  return (
    <section
      style={{
        backgroundImage: `url('${InfoBg}')`,
        backgroundSize: "cover",

        backgroundRepeat: "no-repeat",
        backgroundPosition: "center center",
        // backgroundOrigin: "border-box",
      }}
      className="md:px-20 md:pe-10  min-h-[721px] md:min-h-[unset] xll:pe-20 px-6   flex justify-center flex-col gap-8  py-12 md:py-[12rem] "
    >
      <div className={maxWidth ? maxWidth : "md:max-w-[45%]"}>
        <div
          className={`flex justify-end    flex-col-reverse md:flex-col gap-6 items-start `}
        >
          <div className="flex flex-col gap-4 w-full">
            <h2
              className={`text-white-200 text-[3.7rem] md:text-5xl  lg:text-6xl -tracking-[3.32px] lg:-tracking-[4.2px] `}
            >
              {data.label}
            </h2>
            <p className={`md:text-[1.125rem] text-white-300  text-[1.4rem]  `}>
              {data.description}
            </p>
            <div className=" mt-2 md:mt-4">
              <button
                onClick={() => {
                  window.open(CONSTANTS.MEETING_LINK, "_target")
                }}
                className="border transition-all border-white-200 hover:border-transparent  hover:bg-blue-100 text-white-200  rounded-full text-xl tracking-tight-2%  font-normal py-2 md:py-4 px-5 md:px-16 h-[48px] md:h-16 "
              >
                Schedule a Meeting
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default CommonInfo
